import React from 'react';
import { FaUtensils, FaGlassCheers, FaChalkboardTeacher, FaSwimmer, FaHiking, FaUsers } from 'react-icons/fa';

const services = [
  {
    icon: <FaUsers className="text-4xl text-gold-500" />,
    title: 'Market',
    description: 'Catering to local and international organizations, government officials, and walk-in guests for business and leisure.',
  },
  {
    icon: <FaChalkboardTeacher className="text-4xl text-gold-500" />,
    title: 'Conferencing',
    description: 'Main Conference Hall (100 pax) with modern AV; Executive Meeting Room (20 pax) for smaller gatherings.',
  },
  {
    icon: <FaUtensils className="text-4xl text-gold-500" />,
    title: 'Restaurant',
    description: 'The culinary journey at our restaurant combines local flavors with international cuisine, all prepared with the freshest ingredients by our experienced chefs.',
  },
  {
    icon: <FaGlassCheers className="text-4xl text-gold-500" />,
    title: 'Bar',
    description: 'Our well-stocked bar offers a wide selection of beverages, including wines, spirits, cocktails, and locally brewed beers, ideal for unwinding after a long day.',
  },
  {
    icon: <FaHiking className="text-4xl text-gold-500" />,
    title: 'Leisure & Recreation',
    description: 'A variety of leisure and recreational activities, such as guided nature walks, bird watching, access to hiking trails, and other outdoor adventures, enhance the stay of our guests.',
  },
  {
    icon: <FaSwimmer className="text-4xl text-gold-500" />,
    title: 'Swimming Pool',
    description: 'A beautifully maintained outdoor swimming pool providing a perfect spot for relaxation and recreation, complete with poolside service for snacks and drinks.',
  },
];

const Services = () => {
  return (
    <section id="services" className="py-20">
      <div className="container mx-auto px-4">
        <h2 className="text-4xl font-bold text-center mb-4 text-gray-800">Our Services</h2>
        <p className="text-center text-gray-600 mb-12 max-w-2xl mx-auto">
          Discover the exceptional amenities and experiences we offer at Tuneza Lodge.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="bg-white p-6 rounded-lg shadow-md hover:shadow-xl transition duration-300 border border-gray-100"
            >
              <div className="mb-4">{service.icon}</div>
              <h3 className="text-xl font-semibold mb-3 text-gray-800">{service.title}</h3>
              <p className="text-gray-600">{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;